<script setup lang="ts">
import { computed } from 'vue'

import { Button } from '@collector/shared-ui'
import { YesNoEnum } from '@collector/sportsapi-client-legacy'
import { Route } from '@desktop/router/routes'
import { useEvent } from '@desktop/views/Relation/composables'

import { buttonClass } from './consts'

// composables
const { event } = useEvent()

// computed
const isStatisticsVerified = computed(
  () => event.value.is_stats_verified === YesNoEnum.Yes,
)
</script>

<template>
  <router-link
    v-slot="{ isActive, navigate }"
    :to="{ name: Route.RelationStatistics }"
    custom
  >
    <Button
      :class="[
        buttonClass,
        {
          'bg-success-5! border-success-5! hover:bg-success-6! hover:border-success-6! text-neutral-light-10!':
            isStatisticsVerified,
          'bg-neutral-light-0!': !isStatisticsVerified && isActive,
        },
      ]"
      icon="chart-pie"
      :to="{ name: Route.RelationStatistics }"
      size="sm"
      iconSize="sm"
      @click="navigate"
    >
      <span class="@max-sm:hidden">Statistics</span>
    </Button>
  </router-link>
</template>
